import React, { useMemo } from 'react';

import {

  Bell,

  Search,

  Download,

  Plus,

} from 'lucide-react';

import { getDisplayName } from '../../utils/displayHelpers';

import AdminButton from './ui/AdminButton';

import { LogoMark } from '../Logo';

import '../../styles/admin-theme.css';



const PRIMARY_RAIL_IDS = ['overview', 'bookings', 'users', 'financial', 'analytics'];



const AdminLayout = ({

  user,

  navItems,

  activeTab,

  onTabChange,

  searchQuery = '',

  onSearchChange,

  onExport,

  onPrimaryAction,

  primaryActionLabel = 'Add new',

  children,

}) => {

  const railItems = navItems.filter((item) => PRIMARY_RAIL_IDS.includes(item.id));

  const drawerItems = navItems.filter((item) => !PRIMARY_RAIL_IDS.includes(item.id));



  const activeLabel = useMemo(

    () => navItems.find((item) => item.id === activeTab)?.label || 'Dashboard',

    [navItems, activeTab]

  );



  return (

    <div className="admin-shell">

      <div className="flex min-h-screen">

        {/* Icon rail — desktop */}

        <aside className="admin-bento-nav-rail hidden lg:flex">

          <div className="admin-bento-nav-rail__logo">

            <LogoMark size={22} className="text-[var(--pf-ink)]" />

          </div>



          {railItems.map((item) => {

            const Icon = item.icon;

            const isActive = activeTab === item.id;

            return (

              <button

                key={item.id}

                type="button"

                onClick={() => onTabChange(item.id)}

                title={item.label}

                aria-label={item.label}

                className={`admin-bento-nav-rail__btn ${isActive ? 'admin-bento-nav-rail__btn--active' : ''}`}

              >

                <Icon className="w-[1.125rem] h-[1.125rem]" strokeWidth={2} />

              </button>

            );

          })}



          <div className="flex-1" />



          <button

            type="button"

            className="admin-bento-nav-rail__btn"

            aria-label="Notifications"

          >

            <Bell className="w-[1.125rem] h-[1.125rem]" strokeWidth={2} />

          </button>



          <div

            className="w-9 h-9 rounded-full bg-[var(--pf-accent)] flex items-center justify-center text-white text-xs font-bold"

            title={getDisplayName(user)}

          >

            {getDisplayName(user).charAt(0).toUpperCase()}

          </div>

        </aside>



        {/* Main */}

        <div className="flex-1 flex flex-col min-w-0">

          <header className="sticky top-0 z-30 bg-[#f6f7f5]/90 backdrop-blur-md border-b border-[#e8ece9] px-4 sm:px-6 lg:px-8 py-4">

            <div className="flex flex-col gap-4">

              <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">

                <div className="min-w-0">

                  <p className="text-xs font-bold uppercase tracking-wider text-[#5c6670]">PetsFostering Admin</p>

                  <h1 className="text-xl sm:text-2xl font-bold tracking-tight text-[#0c0f14] truncate">

                    {activeLabel}

                  </h1>

                </div>



                <div className="flex flex-col sm:flex-row sm:items-center gap-3 flex-1 lg:justify-end">

                  <div className="relative flex-1 max-w-xl">

                    <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#5c6670]" />

                    <input

                      type="search"

                      value={searchQuery}

                      onChange={(e) => onSearchChange?.(e.target.value)}

                      placeholder={`Search ${activeLabel.toLowerCase()}…`}

                      className="admin-search"

                    />

                  </div>

                  <div className="flex items-center gap-2 shrink-0">

                    {onExport && (

                      <AdminButton variant="ghost" icon={Download} onClick={onExport}>

                        Export

                      </AdminButton>

                    )}

                    {onPrimaryAction && (

                      <AdminButton icon={Plus} onClick={onPrimaryAction}>

                        {primaryActionLabel}

                      </AdminButton>

                    )}

                  </div>

                </div>

              </div>



              {/* Desktop secondary nav — compact bento pills */}
              {drawerItems.length > 0 && activeTab !== 'overview' && (
                <div className="hidden lg:flex gap-2 overflow-x-auto admin-scroll pb-1">
                  {drawerItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = activeTab === item.id;
                    return (
                      <button
                        key={item.id}
                        type="button"
                        onClick={() => onTabChange(item.id)}
                        className={`admin-pill shrink-0 ${isActive ? 'admin-pill--active' : ''}`}
                      >
                        <Icon className="w-3.5 h-3.5" />
                        {item.label}
                      </button>
                    );
                  })}
                </div>
              )}

              {/* Mobile bento nav strip */}

              <div className="lg:hidden">

                <div className="flex gap-2 overflow-x-auto admin-scroll pb-1">

                  {navItems.map((item) => {

                    const Icon = item.icon;

                    const isActive = activeTab === item.id;

                    return (

                      <button

                        key={item.id}

                        type="button"

                        onClick={() => onTabChange(item.id)}

                        className={`admin-pill shrink-0 ${isActive ? 'admin-pill--active' : ''}`}

                      >

                        <Icon className="w-3.5 h-3.5" />

                        {item.label}

                      </button>

                    );

                  })}

                </div>

              </div>

            </div>

          </header>



          <main className="flex-1 p-4 sm:p-6 lg:p-8 admin-scroll overflow-y-auto">

            {children}

          </main>

        </div>

      </div>

    </div>

  );

};



export default AdminLayout;

